import { BaseAddressViewModel } from '../../../shared/BaseAddressViewModel'
export class RegisterViewModel {
    constructor(parent, options) {
        BaseViewModel.call(this);

        var self = this;
        var requestCounter = 0;

        self.parent = parent;
        self.options = options;

        self.isLoading = ko.observable(true);
        self.isVisible = ko.observable(false);
        self.handleEnter = function () {
            if (!self.isLoading()) {
                self.nextStep();
            }
        };
        
        self.privacyClass = app.orderType === "Shop" ? 'privacyPolicy-link-shop' : 'privacyPolicy-link';
        self.isGuest = ko.observable(false);
        self.isNotGuest = ko.computed(function () {
            return !self.isGuest();
        });
        self.confirmSwitchGuest = function () {
            self.isGuest(true);
            var dialog = app.rootViewModel().dialog;
            dialog.close();
        };
        self.switchGuest = function () {
            if (!self.isGuest()) {        // show modal

                if (app.orderType === "Shop") {
                    self.confirmSwitchGuest();
                    return false;
                }
                else {
                    var dialog = app.rootViewModel().dialog;
                    dialog.styleClasses('info-modal guest-modal');
                    dialog.show('guest-modal', { parent: self });
                    return false;
                }

            }
            self.isGuest(!self.isGuest());
        };

        self.countryList = ko.observableArray();
        self.title1List = ko.observableArray();
        self.title2List = ko.observableArray();

        // get informations
        /*self.privacyIsChecked = ko.observable(false);*/
        self.newsletterChecked = ko.observable(false);
        self.showNewsletterSwitch = ko.observable(true);

        self.userName = ko.observable('');
        self.password = ko.observable('');
        self.validationEnabled = false;
        self.isValidationEnabled = function () {
            return self.validationEnabled;
        };

        self.headText = ko.observable('Jetzt bestellen? Los geht\'s!...');
        self.currentStep = ko.observable(1);
        self.currentStepClass = ko.pureComputed(function () {
            return "step-" + self.currentStep();
        });
        self.isValid = function () {
            var msg = self.errors();
            return msg.length === 0;
        };
        self.validateStep = function () {
            self.isLoading(true);
            self.validationEnabled = true;
            if (!self.validate()) {
                return false;
            }
            return true;
        };
        self.switchToLogin = function () {

            self.parent.ViewMode(0);
            window.document.title = 'Anmelden';
            self.currentStep(1);
        };
        self.setStep = function (step) {
            while (self.isLoading()) {
                _.delay(function () { self.setStep(step); }, 50);
                return;
            }
            if (step !== self.currentStep()) {
                if (step < self.currentStep()) {
                    self.currentStep(step);
                } else {
                    var tries = 0;
                    do {
                        if (!self.nextStep()) {
                            // failed
                            // update hash to match current conditions
                            // self.parent.updateHash(self.parent.ViewMode(), self.currentStep());
                            break;
                        }
                        if (tries > 10) {
                            break;
                        }
                        tries++;
                    } while (self.currentStep() !== step);
                }
            }
        };
        self.nextStep = function () {
            // TODO: validate
            var isValid = true;
            if (!self.isValidating() && !self.isLoading()) {
                isValid = self.validateStep();
            } else {
                isValid = self.isValid();
            }
            if (self.isValidating()) {
                setTimeout(function () {
                    self.nextStep();
                }, 50);
                return false;
            }

            self.isLoading(false);
            if (isValid) {

                if (self.currentStep() >= 2) {

                    // validate address
                    if (self.addressViewModel().hasErrors()) {
                        return false;
                    }

                    // send to server to register
                    self.isLoading(true);
                    var address = self.addressViewModel().serialize();
                    var registerData = {
                        userName: self.userName(),
                        password: self.password(),
                        isGuest: self.isGuest(),
                        orderConfig: self.parent.orderConfig,
                        newsletterChecked: self.newsletterChecked(),
                        address: address,
                        isShop: app.orderType === "Shop"
                    };
                    $.postJSON('/api/account/register', registerData)
                        .done(function (result) {
                            window.document.title = 'Registrieren';
                            // redirect
                            if (!result.Success) {
                                self.isLoading(false);
                                M.toast({ html: 'Bei der Registrierung ist ein Fehler aufgetreten.<br/>Bitte versuchen Sie es später erneut.', classes: 'red', displayLength: 30000 });
                            } else if (_.isString(app.redirectUrl)) {
                                Cookies.remove('.heizoel24.guestorder');
                                window.location = app.redirectUrl;
                            }
                        })
                        .fail(function () {
                            // show notification and error messages
                            self.isLoading(false);
                            M.toast({ html: 'Bei der Registrierung ist ein Fehler aufgetreten.<br/>Bitte versuchen Sie es später erneut.', classes: 'red', displayLength: 30000 });
                        })
                        .always(function () {

                        });

                } else {

                    // TODO: check for valid existent credentials
                    self.currentStep(self.currentStep() + 1);
                    var currStep = self.currentStep();
                    self.parent.updateHash(self.parent.ViewMode(), currStep);
                    if (currStep === 2) {
                        window.document.title = 'Lieferadresse';
                        if (app.orderType === "Shop") {
                            self.headText('Wohin soll der meX gesendet werden?');
                        } else {
                            if (typeof app.productConfig === 'undefined') {
                                self.headText('Wohin soll das Heizöl geliefert werden?');
                            } else {
                                if (app.productConfig.productGroupId == 2)
                                    self.headText('Wohin soll der Diesel geliefert werden?');
                                else
                                    self.headText('Wohin soll das Heizöl geliefert werden?');
                            }
                        }

                        $.postJSON('/api/account/hasNewsletter', self.userName())
                            .done(function (result) {
                                self.showNewsletterSwitch(!result);
                            });
                    } else {
                        if (app.orderType === "Shop") {
                            self.headText('meX bestellen? Los geht\'s!...');
                        } else {
                            self.headText('Jetzt bestellen? Los geht\'s!...');
                        }
                    }
                    self.errorGroup.showAllMessages(false);
                }
            }
            return false;
        };
        self.allowGuestRegistration = ko.computed(function () {
            return self.currentStep() === 1;//self.parent.hasOrderConfig && self.currentStep() === 1;
        });
        self.hasAddress = ko.observable(false);
        self.addressViewModel = ko.observable();

        //var validatePrivacyIsChecked = ko.pureComputed(function () { return self.currentStep() >= 2; });

        //self.privacyIsChecked = self.privacyIsChecked
        //    .extend({
        //        equal: { params: true, message: 'Bitte akzeptieren Sie die Datenschutzbestimmungen', onlyIf: validatePrivacyIsChecked }
        //    });

        self.userName = self.userName
            .extend({
                required: {
                    message: 'Bitte hinterlegen Sie Ihre E-Mail-Adresse.'
                },
                emailExist: {
                    onlyIf: self.isValidationEnabled
                }
            })
            .extend({
                emailValidation: true
            });

        self.password = self.password.extend({
            required: {
                message: 'Bitte geben Sie ein Passwort ein.',
                onlyIf: self.isNotGuest
            },
            minLength: {
                params: 6,
                message: '<strong>Das angegebene Passwort ist zu kurz.</strong><br/>Bitte verwenden Sie mindestens 6 Zeichen.',
                onlyIf: self.isNotGuest
            }
        });

        self.isValidating = ko.computed(function () {
            return self.userName.isValidating();
        });

        /*, self.privacyIsChecked*/
        self.errorGroup = ko.validation.group([self.userName, self.password]);

        self.errors = ko.computed(function () {
            var messages = self.errorGroup();

            if (self.currentStep() >= 2 && self.hasAddress()) {
                if (self.addressViewModel().hasErrors()) {
                    messages = messages.concat(self.addressViewModel().visibleErrors());
                }
            }

            return _.uniq(messages);
        });
        self.visibleErrors = ko.computed(function () {
            var errors = [];
            self.errorGroup.forEach(function (observable) {
                if (ko.validation.utils.isValidatable(observable) && !observable.isValid() && observable.isModified()) {
                    errors.push(observable.error.peek());
                }
            });

            if (self.currentStep() >= 2 && self.hasAddress()) {
                errors = errors.concat(self.addressViewModel().visibleErrors());
            }
            return errors;
        });
        self.hasErrors = ko.computed(function () {
            return self.visibleErrors().length > 0;
        });
        self.validateObservable = function (observable) {
            if (ko.validation.utils.isValidatable(observable)) {
                ko.validation.validateObservable(observable);
            }
        };
        self.validate = function () {
            if (self.currentStep() >= 2 && self.hasAddress()) {

                self.addressViewModel().validate();
            }
            self.validateObservable(self.userName);
            var msg = self.errors();
            self.errorGroup.showAllMessages();
            var valid = msg.length === 0;
            self.validationEnabled = false;
            return valid;
        };
        self.errorGroup.showAllMessages(false);


        self.handleLoaded = function () {
            if (requestCounter === 3) {
                var isInstallment = false;
                if (self.parent.hasOrderConfig) {
                    isInstallment = self.parent.orderConfig.isInstallment;
                }
                requestCounter = 0;

                $(document).off('ajaxSuccess', self.handleLoaded);

                self.addressViewModel(new BaseAddressViewModel(self,
                    {
                        isOrder: self.parent.hasOrderConfig,
                        allowInvoiceAddress: !isInstallment,
                        showInstallmentHint: isInstallment
                    }));
                self.hasAddress(true);
                self.isLoading(false);
                self.errorGroup.showAllMessages(false);
            }
        };
        self.init = function () {

            $.getInitRequest('/api/location/get/countries', function (result) {
                self.countryList(result);
                requestCounter++;
            });
            $.getInitRequest('/api/titel/anrede', function (result) {
                self.title1List(result);
                requestCounter++;
            });
            $.getInitRequest('/api/titel/titel', function (result) {
                self.title2List(result);
                requestCounter++;
            });

            if (app.orderType === "Shop") {
                self.headText('meX bestellen? Los geht\'s!...');
            } else {
                self.headText('Jetzt bestellen? Los geht\'s!...');
            }

            $(document).ajaxSuccess(self.handleLoaded);
        };

        self.init();
    }
}
Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};
ExtendViewModel(RegisterViewModel, BaseViewModel);